import React, { useState } from 'react';
import Swal from 'sweetalert2';
import api from '../../../../config/axios';

import { FaTimes, FaRegSave } from 'react-icons/fa';

const ReabrirCaixaModal = ({ onClose, caixa, onCaixaAtualizado }) => {
    const [observacoes, setObservacoes] = useState(caixa.observacoes || '');

    const handleReabrirCaixa = async () => {
        try {
            const result = await Swal.fire({
                title: 'Atenção!',
                text: 'Confirmar a reabertura do caixa?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim, confirmar!',
                cancelButtonText: 'Cancelar'
            });

            if (!result.isConfirmed) {
                return;
            }
            
            const data = {
                caixa_id: caixa.id,
                observacoes: observacoes
            };

            await api.post(`/caixas/reabrir`, data);

            Swal.close();
            onCaixaAtualizado();
            onClose();
            Swal.fire('Sucesso', 'Caixa reaberto com sucesso!', 'success');
        } catch (error) {
            Swal.close();
            Swal.fire('Erro', 'Erro ao reabrir caixa', 'error');
        }
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">Reabrir Caixa</h4>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="modal-body">
                        <div className="row">
                            <div className="col-12">
                                <p className="mb-2">
                                    <strong>Responsável:</strong> {caixa.colaborador.nome}
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <p className="mb-2">
                                    <strong>Data de Abertura:</strong> {new Date(caixa.data_abertura).toLocaleString('pt-BR').replace(',', '')}
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <p className="mb-2">
                                    <strong>Data de Fechamento:</strong> {new Date(caixa.data_fechamento).toLocaleString('pt-BR').replace(',', '')}
                                </p>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-12">
                                <label className="form-label fw-bold">Observações</label>
                                <textarea
                                    className="form-control"
                                    rows={5}
                                    placeholder="Digite as observações para a reabertura do caixa..."
                                    value={observacoes}
                                    onChange={(e) => setObservacoes(e.target.value)}
                                />
                            </div>
                        </div>
                    </div >

                    <div className="modal-footer">
                        <button type="button" className="btn btn-outline-danger" onClick={onClose}>
                            <FaTimes className="me-1" />
                            Fechar
                        </button>
                        <button type="button" className="btn btn-custom-primary" onClick={handleReabrirCaixa}>
                            <FaRegSave /> Salvar
                        </button>
                    </div>
                </div >
            </div >
        </div >
    );
};

export default ReabrirCaixaModal; 